export default "__VITE_ASSET__7e82d848__"